import React from "react";

export default function SpecialOrderAndFooter({ onOpenDatenschutz }) {
  const handleSpecialOrderClick = () => {
    window.location.href = "https://beyzadebaklava.de/";
  };

  return (
    <>
      <div className="section" id="sonderbestellung">
        <div className="special-card">
          <span className="eyebrow">BESONDERE ANLÄSSE</span>
          <h2>Eine süße Note für unvergessliche Momente</h2>
          <p>
            Für Geburtstage, Verlobungen, Hochzeiten und individuelle
            Bestellungen.
          </p>
          <button className="primary-btn" onClick={handleSpecialOrderClick}>
            SONDERBESTELLUNG
          </button>
        </div>
      </div>

      <footer className="footer-links">
        <button
          onClick={onOpenDatenschutz}
          style={{
            background: "none",
            border: "none",
            color: "var(--muted)",
            cursor: "pointer",
            font: "inherit",
            fontSize: "12px",
          }}
        >
          Datenschutzerklärung
        </button>
        <span>•</span>
        <a href="#impressum">Impressum</a>
      </footer>
    </>
  );
}
